export class FrequencyOfReactionModel {
  public frequencyOfReactionId: number;
  public frequencyName: string;
  public frequencyDescription: string;
}